import { render, staticRenderFns } from "./PriceNegotiationEdit.vue?vue&type=template&id=0cb0c8be&"
import script from "./PriceNegotiationEdit.vue?vue&type=script&lang=js&"
export * from "./PriceNegotiationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports